<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">达人提现</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>达人状态：</label>
          <el-select v-model="status" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in statusArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>
          <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <el-button type="success" @click="batchUpdate(2)" v-loading="bitchPassLoading">批量通过</el-button>
          <el-button type="danger"  @click="batchUpdate(3)" v-loading="bitchRejectLoading">批量不通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="updateTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" class-name="cursor">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="224">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,birth"/>
              <p>身高：{{ scope.row.height }}cm</p>
              <p>现居城市：{{ scope.row.city }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="奖品金额(元）" v-if="checkColList.indexOf('奖品金额(元）') > -1" ></el-table-column>
          <el-table-column prop="remitTime" label="奖品发送时间" v-if="checkColList.indexOf('奖品发送时间') > -1" ></el-table-column>
          <el-table-column prop="" label="提现信息" v-if="checkColList.indexOf('提现信息') > -1" >
            <template #default="scope">
              <p>姓名：{{scope.row.alipayName}}</p>
              <p>支付宝账号：{{scope.row.alipayAccount}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1" >
            <template #default="scope">
              <p>{{scope.row.status == 0 ? '未提交' : scope.row.status == 1 ? '待审核' : scope.row.status == 2 ? '已通过' :  scope.row.status == 3 ? '不通过' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; align-items: center; justify-content: space-between">
          <div style="font-weight: bold">合计：{{sum}} 元</div>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getAwardPageList, getPageAwardSummary
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import UpdateAwardStateDialog from "@/views/talent/components/UpdateAwardStateDialog";

export default {
  name: "TalentAward",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      statusArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '不通过', value: 3}
      ],
      status: 1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,

      sum: 0,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['时间', '头像', '用户信息', '奖品金额(元）', '奖品发送时间', '提现信息', '状态', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,

      idArray: [],
      limitState: false,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    // getExpireTime(val) {
    //   this.startExpire = val[0];
    //   this.endExpire = val[1];
    //   // console.log(val)
    // },
    //
    // getExpireCheck(val) {
    //   this.isExpireChecked = val
    // },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.status = 1;
      this.sex = -1;
      this.searchValue = '';
      this.limitState = false;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['status'] = this.status;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      param['searchType'] = this.searchType;
      param['sex'] = this.sex;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getAwardPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
          this.getSummary(param)
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getSummary(param) {
      getFormData(getPageAwardSummary, param).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.sum = data.data
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },



    batchUpdate(state) {
      if(this.idArray.length > 0) {
        let _title = (state == 2?'通过':'不通过') + '后的小助手通知内容：'
        let _this = this
        Dialog.open({
          title: _title,
          component: UpdateAwardStateDialog,
          data: {
            idArray: this.idArray,
            state: state,
            width: '500px',
          },
          confirm: (()=>{
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }
          })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
